<template>
    <div>
        <footer id="footer" class="sitecolor-content">
            <div v-if="patrocinadores?.length > 0" class="prefooter altcolor-content padding-vertical-content">
                <div class="tw:container tw:mx-auto tw:px-4">
                    <div class="tw:flex tw:flex-wrap tw:items-center tw:justify-center">
                        <div class="tw:w-full tw:text-center">
                            <div class="tw:text-2xl tw:font-bold tw:mb-4 tw:mt-0 tw:uppercase">{{ textosTeatro.t('footer.patrocinadores') }}</div>
                            <carousel
                                :per-page="2"
                                :mouse-drag="false"
                                :loop="true"
                                :autoplay="true"
                                :autoplayTimeout="2000"
                                :autoplayHoverPause="true"
                                :scrollPerPage="true"
                                :perPageCustom="[[480, 3], [768, 4], [992, 6]]"
                                :centerMode="true"
                            >
                                <template v-for="(patrocinador, index) in patrocinadores">
                                    <slide v-bind:key="index">
                                        <a :href="patrocinador.url" target="_blank">
                                            <img :src="patrocinador.imagen_url" />
                                        </a>
                                    </slide>
                                </template>
                            </carousel>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tw:container tw:mx-auto tw:px-4 tw:py-4">
                <div class="tw:flex tw:flex-col tw:sm:flex-row tw:gap-6 md:tw:gap-4 lg:tw:gap-0">
                    <div class="tw:w-full tw:flex tw:flex-col tw:items-center md:tw:w-1/2 lg:tw:w-1/4">
                        <div class="tw:text-2xl tw:font-bold tw:mb-4">
                            {{ $t('footer.contacto') }}
                        </div>
                        <div v-html="footer.contacto">

                        </div>
                    </div>

                    <div class="tw:w-full md:tw:w-1/2 lg:tw:w-1/2 tw:flex tw:flex-col tw:items-center tw:gap-4">
                        <div class="tw:text-2xl tw:font-bold tw:mb-4">
                            {{ configuracion.title }}
                        </div><a href="https://www.compralaentrada.com/" class="logo"><img src="https://apiteatros.compralaentrada.com/images/logo_compralaentrada_white.png" width="50"/></a>

                        <ul class="tw:list-none tw:p-0 tw:m-0 tw:flex tw:flex-wrap tw:gap-4 md:tw:gap-6 lg:tw:gap-8 tw:justify-center">
                            <li>
                                <router-link
                                    :to="{ name: 'legal' }"
                                    class="home-link tw:text-white tw:hover:text-gray-300 tw:transition-colors tw:flex tw:text-center tw:justify-center tw:items-center"
                                >
                                    <span>{{ $t('footer.legal') }}</span>
                                </router-link>
                            </li>

                            <li>
                                <router-link
                                    :to="{ name: 'privacidad' }"
                                    class="home-link tw:text-white tw:hover:text-gray-300 tw:transition-colors tw:flex tw:text-center tw:justify-center tw:items-center"
                                >
                                    <span>{{ $t('footer.privacidad') }}</span>
                                </router-link>
                            </li>

                            <li v-if="footer.condiciones_generales">
                                <router-link
                                    :to="{ name: 'condiciones_generales' }"
                                    class="home-link tw:text-white tw:hover:text-gray-300 tw:transition-colors tw:flex tw:text-center tw:justify-center tw:items-center"
                                >
                                    <span>{{ $t('footer.condiciones') }}</span>
                                </router-link>
                            </li>

                            <li>
                                <router-link
                                    :to="{ name: 'front.faqs.index' }"
                                    class="home-link tw:text-white tw:hover:text-gray-300 tw:transition-colors tw:flex tw:text-center tw:justify-center tw:items-center"
                                >
                                    <span>FAQ</span>
                                </router-link>
                            </li>
                            <li>
                                <a class="home-link tw:text-white tw:hover:text-gray-300 tw:transition-colors" href="https://www.compralaentrada.com/quienes-somos">{{ $t('footer.quienes_somos') }}</a>
                            </li>
                        </ul>
                    </div>

                    <div class="tw:w-full md:tw:w-1/2 lg:tw:w-1/4 tw:flex tw:flex-col tw:items-center">
                        <div class="tw:text-2xl tw:font-bold tw:mb-4">
                            {{ $t('footer.siguenos') }}
                        </div>

                        <ul class="social-links tw:list-none tw:flex tw:flex-wrap tw:gap-4 tw:justify-center lg:tw:justify-start">
                            <li v-if="footer.facebook" >
                                <a :href="footer.facebook" target="_blank" class="tw:text-white tw:hover:text-gray-300 tw:transition-colors tw:inline-flex tw:items-center tw:justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
                                        <path d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z" fill="currentColor"/>
                                    </svg>
                                </a>
                            </li>

                            <li v-if="footer.twitter">
                                <a :href="footer.twitter" target="_blank" class="tw:text-white tw:hover:text-gray-300 tw:transition-colors tw:inline-flex tw:items-center tw:justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M8 2H1l8.26 11.015L1.45 22H4.1l6.388-7.349L16 22h7l-8.608-11.478L21.8 2h-2.65l-5.986 6.886zm9 18L5 4h2l12 16z"/>
                                    </svg>
                                </a>
                            </li>

                            <li v-if="footer.instagram">
                                <a :href="footer.instagram" target="_blank" class="tw:text-white tw:hover:text-gray-300 tw:transition-colors tw:inline-flex tw:items-center tw:justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"/>
                                    </svg>
                                </a>
                            </li>

                            <li v-if="footer.tiktok">
                                <a :href="footer.tiktok" target="_blank" class="tw:text-white tw:hover:text-gray-300 tw:transition-colors tw:inline-flex tw:items-center tw:justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.74a4.85 4.85 0 0 1-1.01-.05z"/>
                                    </svg>
                                </a>
                            </li>

                            <li v-if="footer.linkedin">
                                <a :href="footer.linkedin" target="_blank" class="tw:text-white tw:hover:text-gray-300 tw:transition-colors tw:inline-flex tw:items-center tw:justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                                    </svg>
                                </a>
                            </li>

                            <li v-if="footer.youtube">
                                <a :href="footer.youtube" target="_blank" class="tw:text-white tw:hover:text-gray-300 tw:transition-colors tw:inline-flex tw:items-center tw:justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script setup>
    import { computed, getCurrentInstance } from 'vue';
    import { useTextosTeatro } from '@/composables/common/useTextosTeatro';
    import { Carousel, Slide } from 'vue-carousel';

    const props = defineProps({
        configuracion: { type: Object, default: () => ({}) },
        footer: { type: Object, default: () => ({}) },
        patrocinadores: { type: Array, default: () => [] }
    });
    const configuracion = computed(() => props.configuracion);

    // CB Zaragoza llama "apoyos" a sus patrocinadores.
    const proxy = getCurrentInstance().proxy;
    const textosTeatro = computed(() => useTextosTeatro(proxy.$i18n, configuracion.value?.hash_teatro));
    const footer = computed(() => props.footer);
    const patrocinadores = computed(() => props.patrocinadores);
</script>